'use-strict';

/* @ngInject */
export default function DocumentController(
  $rootScope,
  $scope,
  fileService,
  interfaceService,
  usersService,
  toastService,
) {
  $scope.document = null;

  /**
   * Depending on the file's content_type a FontAwesome icon is selected
   */
  const fileExtensionToIcon = () => {
    switch ($scope.document.content_type) {
      case 'application/pdf':
        $scope.fileIcon = 'fad fa-file-pdf';
        break;
      case 'image/jpeg':
      case 'image/png':
        $scope.fileIcon = 'fad fa-file-image';
        break;
      default:
        $scope.fileIcon = 'fad fa-file';
        break;
    }
  };

  const getUploaderName = () => {
    $scope.document.uploader = usersService.getNameOfUser($scope.document.uploader);
  };

  const getFileMeta = () => {
    fileService.getFileMeta($scope.documentId)
      .then((res) => {
        $scope.document = res.data;
        fileExtensionToIcon();
        getUploaderName();
        interfaceService.applyScope($scope);
      })
      .catch((e) => {
        toastService.toast('error', 'Fehler beim Laden des Dokuments');
        console.error(e);
      });
  };

  /**
   *
   * @param {Integer} fileId
   */
  $scope.deleteFile = async (fileId) => {
    fileService
      .deleteFile(fileId)
      .then(() => {
        toastService.toast('success', 'Die Datei wurde gelöscht.');
        $rootScope.$emit('updateSalesTableDetail');
      })
      .catch((err) => {
        toastService.toast('error', 'Fehler beim Löschen der Datei.');
        console.error(err);
      });
  };

  /**
   * Download the specified `file` from the file server.
   *
   * @param {int} fileId
   * @param {string} fileName
   */
  $scope.downloadFile = () => {
    fileService.getFile($scope.document.id, $scope.document.name);
  };

  const init = () => {
    getFileMeta();
  };

  init();
}
